import React from "react";
import { useSite } from "../context/SiteContext";
import useReveal from "../hooks/useReveal";

export default function Bloodline() {
  useReveal();
  const { c } = useSite();
  const { bloodline } = c;
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section className="bg-ink py-28 sm:py-40">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
        <span className="eyebrow">{bloodline.label}</span>
        <h2 className="reveal font-display text-5xl sm:text-7xl font-light text-parchment mt-6 leading-[0.98]">
          {bloodline.title}
        </h2>
        <p className="reveal mt-7 text-xl leading-relaxed text-parchment/65 font-light">{bloodline.text}</p>
        <button
          onClick={() => go("gathering")}
          className="reveal mt-10 font-label text-[0.72rem] uppercase tracking-[0.22em] text-ink bg-gold px-9 py-4 hover:bg-parchment transition-colors duration-300"
        >
          {bloodline.cta}
        </button>
      </div>
    </section>
  );
}
